import superModule from "./superModule";
import {$WS} from "../../WsSdk/webSocketProtocol/webSocketProtoHead";
import {services} from "../gameEngine";
import data_control from "../libs/data_control";

//
export class HandleMessage {
    [head: string]: (((data?: any) => void)[]);
}

export default class GameWebSocketModule extends superModule {

    protected m_className: string = 'webSocket网络模块';

    constructor() {
        super();
    }

    //地址
    private m_ws: WebSocket = null;
    //
    private m_message: HandleMessage = new HandleMessage();

    async preLoadModules(): Promise<void> {
        await super.preLoadModules();
    }

    async loadModule(): Promise<void> {
        //
        await super.loadModule();
    }

    //连接服务器
    async connectServer(url: string): Promise<boolean> {
        return new Promise(resolve => {
            //
            resolve(true);
        })
    }

    addMessageOnEvent(head: string, callback: (data?: any) => void) {
        if (this.m_message[head] == null) {
            this.m_message[head] = [];
        }
        this.m_message[head].push(callback);
    }

    removeMessageEvent(head: string, callback: (data?: any) => void = null) {
        if (this.m_message[head] == null) return;

        if (callback == null) {
            this.m_message[head].length = 0;
        } else {
            let pos = this.m_message[head].indexOf(callback);
            if (pos >= 0) {
                this.m_message[head].splice(pos, 1);
            }
        }
    }

    disconnectServer() {
        if (this.m_ws && this.m_ws.readyState != this.m_ws.CLOSED && this.m_ws.readyState != this.m_ws.CLOSING) {
            this.m_ws.close();
        }
    }

    sendMessage(messageText: string): boolean {
        if (null == this.m_ws) {
            console.error('#48 未创建Websocket');
            return false;
        }
        if (this.m_ws.readyState != this.m_ws.OPEN) {
            console.warn('#52 与服务器的连接已断开');
            return false;
        }
        console.log('发送数据', messageText);
        this.m_ws.send(messageText);
        return true;
    }
}